import React, { useState } from "react";
import {
  Box,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

export const Page1 = () => {
  const [outerDrawerOpen, setOuterDrawerOpen] = useState(false);
  const [innerDrawerOpen, setInnerDrawerOpen] = useState(false);

  const toggleOuterDrawer = (open: boolean) => () => {
    setOuterDrawerOpen(open);
  };

  const toggleInnerDrawer = (open: boolean) => () => {
    setInnerDrawerOpen(open);
  };

  return (
    <div>
      <Button onClick={toggleOuterDrawer(true)}>Open Outer Drawer</Button>

      <Drawer
        anchor="left"
        open={outerDrawerOpen}
        onClose={toggleOuterDrawer(false)}
      >
        <Box sx={{ width: 300, padding: 2 }}>
          <Typography variant="h6">Outer Drawer</Typography>
          <List>
            <ListItem onClick={toggleInnerDrawer(true)}>
              <ListItemText primary="Open Inner Drawer" />
            </ListItem>
            {/* Other items for the outer drawer */}
          </List>

          <Drawer
            anchor="left"
            open={innerDrawerOpen}
            onClose={toggleInnerDrawer(false)}
          >
            <Box sx={{ width: 200, padding: 2 }}>
              <Typography variant="h6">Inner Drawer</Typography>
              {/* Content for the inner drawer */}
            </Box>
          </Drawer>
        </Box>
      </Drawer>
    </div>
  );
};
